module.exports = __webpack_public_path__ + "img/tortellini-alle-erbe.3af6841c.png";